import React from "react";
import { observer } from "mobx-react";
import { TenantViewStore } from "../../store";
import { TenantViewForm } from "./TenantViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type TenantViewProps = {
  tenantViewStore: TenantViewStore;
};

export const TenantView: React.FC<TenantViewProps> = observer(
  ({ tenantViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <TenantViewForm
          tenantViewStore={tenantViewStore}
          name={tenantViewStore.nameValue}
          tenantTypeValue={tenantViewStore.tenantTypeValue}
          statusValue={tenantViewStore.statusValue}
          planValue={tenantViewStore.planValue}
          logoFiles={tenantViewStore.logoFiles}
          publicUrl={tenantViewStore.publicUrlValue}
          idERP={tenantViewStore.idERPValue}
          idCRM={tenantViewStore.idCRMValue}
          monthlyTokenLimit={tenantViewStore.monthlyTokenLimitValue}
          currentMonthTokens={tenantViewStore.currentMonthTokensValue}
          tokenLimitResetDay={tenantViewStore.tokenLimitResetDayValue}
          lastTokenResetDate={tenantViewStore.lastTokenResetDateValue}
          ragLlmProviderValue={tenantViewStore.ragLlmProviderValue}
          ragLlmModel={tenantViewStore.ragLlmModelValue}
          currentStorageBytes={tenantViewStore.currentStorageBytesValue}
          storageByteLimit={tenantViewStore.storageByteLimitValue}
          eSignatureProviderOptions={tenantViewStore.getESignatureProviderOptions()}
          eSignatureProvider={tenantViewStore.eSignatureProviderValue}
          onPrint={(handlePrint: () => void) =>
            tenantViewStore.printTenant(handlePrint)
          }
          onCancel={() => tenantViewStore.cancelTenant()}
          onEdit={
            tenantViewStore.isEditEnabled
              ? () => tenantViewStore.editTenant()
              : undefined
          }
          logoViewAction={getViewAction(
            (props) => tenantViewStore.fileDownload(props, "logo"),
            (props) => tenantViewStore.viewFilePdf(props, "logo")
          )}
        />
        <ErrorDialog
          open={tenantViewStore.errorDialogOpened}
          title={tenantViewStore.errorTitle}
          description={tenantViewStore.errorDescription}
          onClose={() => tenantViewStore.closeErrorDialog()}
        />
        <PDFViewerDialog
          open={tenantViewStore.pdfViewerOpen}
          onClose={() => tenantViewStore.closePdfViewer()}
          pdfUrl={tenantViewStore.pdfViewerUrl}
          title={tenantViewStore.pdfViewerTitle}
        />
      </div>
    );
  }
);
